import { render, staticRenderFns } from "./RegisterPageHeader.vue?vue&type=template&id=5752ce57&scoped=true&"
import script from "./RegisterPageHeader.vue?vue&type=script&lang=js&"
export * from "./RegisterPageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752ce57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5752ce57')) {
      api.createRecord('5752ce57', component.options)
    } else {
      api.reload('5752ce57', component.options)
    }
    module.hot.accept("./RegisterPageHeader.vue?vue&type=template&id=5752ce57&scoped=true&", function () {
      api.rerender('5752ce57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/register/components/RegisterPageHeader.vue"
export default component.exports